import { Disclosure, DisclosureClose } from '../utils/Disclosure';

const toggleElements = document.querySelectorAll('.js-aria-toggle');
const closeElements = document.querySelectorAll('.js-aria-close');

toggleElements.forEach((toggleElement) => {
    // Initialisation du disclosure
    const disclosure = new Disclosure(
        toggleElement,
        {
            slide: false,
        }
    );
    disclosure.init();

    toggleElement.addEventListener('click', (event) => {
        if (event.currentTarget !== disclosure.trigger) {
            if (disclosure.isOpen()) {
                disclosure.hide();
            }
        }
    });

    // On reprend le comportement de bootstrap en mettant la classe active sur le toggleElement
    toggleElement.addEventListener('disclosure.show', () => {
        toggleElement.classList.add('active');
    });

    toggleElement.addEventListener('disclosure.hide', () => {
        toggleElement.classList.remove('active');
    });
});

closeElements.forEach((closeElement) => {
    // Initialisation du disclosure
    const closeDisclosureButton = new DisclosureClose(closeElement);
    closeDisclosureButton.init();
});
